import { AnalyticsBrandSettings, AnalyticsEventData } from 'idt-analytics-api/models';
import { getDefaultAnalytics } from '../helpers/events.helper';
import { AnalyticsHelpersOysho } from '../helpers/brand-analytics.helpers.oy';
import { AnalyticsGTMSettings, DefaultAnalyticsSettings } from 'analytics-api';
import { AnalyticsOyshoEventDataHelpers } from '../helpers/brand-analytics-event-data.helpers.oy';

export const HelpCenterEvents: AnalyticsBrandSettings = {

  centroDeAyudaAyudaClickPregunta(data: AnalyticsEventData): AnalyticsGTMSettings {
    const componentData = data.componentData as { topic: string; searchTerm: string; question: string }
    const topic = componentData?.topic;
    const question = componentData?.question || 'ver_todo';
    const eventSettings: DefaultAnalyticsSettings = getDefaultAnalytics('analyticsEvent', 'ayuda', 'centro_de_ayuda', 'click_pregunta', `${topic}/${question}`);
    return AnalyticsOyshoEventDataHelpers.setGTMSettings(eventSettings);
  },

  centroDeAyudaAyudaBuscador(data: AnalyticsEventData): AnalyticsGTMSettings {
    const componentData = data.componentData as { topic: string; searchTerm: string; question: string }
    const label = componentData?.searchTerm;
    const eventSettings: DefaultAnalyticsSettings = getDefaultAnalytics('analyticsEvent', 'ayuda', 'centro_de_ayuda', 'buscador', label);
    return AnalyticsOyshoEventDataHelpers.setGTMSettings(eventSettings);
  },

  centroDeAyudaAyudaContacto(data: AnalyticsEventData): AnalyticsGTMSettings {
    const eventSettings: DefaultAnalyticsSettings = getDefaultAnalytics('analyticsEvent', 'ayuda', 'centro_de_ayuda', 'contacto');
    return AnalyticsOyshoEventDataHelpers.setGTMSettings(eventSettings);
  },

  centroDeAyudaAyudaVolverAtras(data: AnalyticsEventData): AnalyticsGTMSettings {
    const eventSettings: DefaultAnalyticsSettings = getDefaultAnalytics('analyticsEvent', 'ayuda', 'centro_de_ayuda', 'volver_atras');
    return AnalyticsOyshoEventDataHelpers.setGTMSettings(eventSettings);
  },

  centroDeAyudaAyudaDesplegar(data: AnalyticsEventData): AnalyticsGTMSettings {
    const componentData = data.componentData as { topic: string; searchTerm: string; question: string }
    const question = componentData?.question;
    const eventSettings: DefaultAnalyticsSettings = getDefaultAnalytics('analyticsEvent', 'ayuda', 'centro_de_ayuda', 'desplegar', question);
    return AnalyticsOyshoEventDataHelpers.setGTMSettings(eventSettings);
  },

};